import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import React from 'react';
import type { PropsWithChildren } from 'react';

import AbortError from 'api/AbortError';
import RequestError from 'api/RequestError';

export function QueryProvider({ children }: PropsWithChildren<object>) {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				retry: (failureCount, error) => {
					if (error instanceof AbortError) {
						return false;
					}

					if (error instanceof RequestError && error.status >= 400 && error.status < 500) {
						return false;
					}

					return failureCount < 3;
				},
				retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
			},
		},
	});

	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
